import { decimalFormat, sharesFormat } from 'common/formats/formats';

export const getOptionsLedgerColConfig = (isOption: boolean) => [
  {
    value: 'Shares',
    alias: 'shares',
    width: '100%',
    format: sharesFormat,
    minValue: 1,
    gridType: 'number',
  },
  {
    value: 'Strike Price',
    alias: 'price',
    width: '100%',
    format: {
      ...decimalFormat(),
      maximumFractionDigits: 15,
      maximumFractionDigitsWhenEditing: 15,
      style: 'currency',
    },
    ...(isOption ? { minValue: 0, preserveZeroValue: true } : { greaterThan: 0 }),
    isRequired: true,
    gridType: 'number',
  },
];
